import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Alert, Form } from 'grab-ui';
import { UCD_ACTION_TYPES, UCD_RESOURCE_NAMES, UCD_ROUTES_LINK } from 'omega-rtc/constants/ucd';
import ShowIfAuthorized from 'omega-rtc/components/form/ucd/common/ShowIfAuthorized';

import './CreateTridentCampaign.scss';

import _ from 'lodash';
import { getRequestStateKey } from 'omega-rtc/utils/ucd-utils';
import { CREATE_TRIDENT_CAMPAIGN, createTridentCampaign } from 'omega-rtc/actions/ucd';
import TridentCampaignPage from 'omega-rtc/views/ucd/trident/TridentCampaignPage';
import { TridentCampaignFormData } from 'omega-rtc/types/ucd/campaign';
import { hasJustSuccess, isRequestsPending } from 'omega-rtc/utils/request-state-utils';
import Toastr from 'omega-rtc/utils/toastr-util';
import { Dimmer, Loader } from 'semantic-grab-ui';
import { constructConditionFormData } from 'omega-rtc/utils/simple-scenario-utils';


type Props = {
  createTridentCampaignRequest: Any,
  createCampaign: Function,
  projectID: string,
  campaignID: string,
  user: any
}

class CreateTridentCampaign extends Component {
  props: Props;
  constructor(props: Props) {
    super(props);
    this.state = {
      currentPageIndex: 1,
      formData: {},
    };
  }

  handleSubmitForm = (formData: TridentCampaignFormData) => {
    // Set state so if the HTTP response is not successfull the rendered children component still showing the latest form value
    const currentPageIndex = 2;
    this.setState({ formData, currentPageIndex });


    const updatedFormData = _.cloneDeep(formData);
    updatedFormData.condition = constructConditionFormData(updatedFormData);

    const { createCampaign, projectID, campaignID, user } = this.props;
    createCampaign({
      user: user.email,
      campaign: updatedFormData,
    }, projectID, campaignID);
  };

  componentDidUpdate(prevProps) {
    const prev = prevProps.createTridentCampaignRequest;
    const current = this.props.createTridentCampaignRequest;

    // has just successfully submitted the form
    if (hasJustSuccess(prev, current)) {
      Toastr.success('Campaign has been successfully created');
      this.props.router.push(
        UCD_ROUTES_LINK.CAMPAIGN_VIEW(this.props.projectID, this.props.campaignID),
      );
    }
  }


  render() {
    const { formData, currentPageIndex } = this.state;
    const { createTridentCampaignRequest, params } = this.props;

    const mandatoryCondition = {
      selectedCities: [6],
      selectedTaxiTypes: [249],
    };

    // When submitting the form and pending for Http Response
    if (isRequestsPending(createTridentCampaignRequest)) {
      return <Dimmer inverted active> <Loader /> </Dimmer>;
    }

    return (
      <div className={'ucd-basic trident-campaign-page'}>
        <h3 className={'trident-campaign-page-title'}>Create Trident Campaign</h3>
        <TridentCampaignPage
          params={params}
          formData={formData}
          mandatoryCondition={mandatoryCondition}
          currentPageIndex={currentPageIndex}
          handleSubmitForm={this.handleSubmitForm}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: StoreState, ownProps: Object) => {
  const userPermissions = state.app.user.userPermissions;
  return {
    projectID: ownProps.params.entityID,
    campaignID: ownProps.params.campaignID,
    user: state.app.user,
    userPermissions,
    createTridentCampaignRequest: _.get(
      state.requests,
      getRequestStateKey(CREATE_TRIDENT_CAMPAIGN),
      {},
    ),
  };
};


const mapDispatchToProps = dispatch => ({
  createCampaign: (data, projectID, campaignID) => {
    dispatch(createTridentCampaign(data, projectID, campaignID));
  },
});


const FormHOC = Form.create();
const TridentCampaignCreatePageAuthorized = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FormHOC(CreateTridentCampaign));


// page-level access control
const TridentCampaignCreatePageComponent = (props: Props) => (
  <ShowIfAuthorized
    conditions={[
      {
        resource: UCD_RESOURCE_NAMES.campaign,
        action: UCD_ACTION_TYPES.create,
      },
    ]}
    unauthorizedContent={
      <Alert
        message="You don't have permission to create campaign"
        showIcon
        type="error"
      />
    }
  >
    <TridentCampaignCreatePageAuthorized {...props} />
  </ShowIfAuthorized>
);


export default TridentCampaignCreatePageComponent;

